<!-- 平台查看多控销售统计 --  报表 -->
<template>
    <div class="pl-sales-statistic-table">
        <myTable :selection="false" :page="page" :showpage="true" :operation="false" v-loading="isLoading"
            :table-data="tableData" :table-option.sync="tableOption" @page-change="getList" :expand="false">
        </myTable>
    </div>
</template>

<script>
import myTable from "@/components/myTable";
import {
  goodsStatisticsForPlatform,
  goodsStatisticsPageForPlatform
} from '@/api/saleRule/productLine'
export default {
    name: 'PlSalesStatisticTable',
    components: {
        myTable
    },
    data() {
        return {
            page: {
                total: 0,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
            tableData: [],
            tableOption: [
                { label: "产品线名称", prop: "name" },
                { label: "产品名称", prop: "goodsName" },
                { label: "销售数量", prop: "goodsNum" },
                { label: "商品单价", prop: "price" },
                { label: "缴费前小计（元）", prop: "totalMoney" },
                { label: "技术服务费（元）", prop: "servicePrice" },
                { label: "退款金额（元）", prop: "refundTotalMoney" },
                { label: "成交金额（元）", prop: "settledMoney" },
                { label: "结算状态", prop: "settledStatus" },
                { label: "客户名称", prop: "shopName" },
                { label: "客户所在省", prop: "provinceName" },
                { label: "客户所在市", prop: "cityName" },
                { label: "客户所在区", prop: "areaName" },
                { label: "产品规格", prop: "specification" },
                { label: "生产厂家", prop: "factory" },
                { label: "代理", prop: "cooperationName" },
                { label: "医药公司", prop: "pharmaceuticalName" },
                { label: "团队", prop: "teamName" },
                { label: "所属组织层级", prop: "district" },
                { label: "所属业务员", prop: "salesUser" },
                { label: "产品控销分类", prop: "bagType" },
                { label: "下单时间", prop: "orderTime" },
                { label: "完成收货时间", prop: "finishDate" },
                { label: "订单编号", prop: "orderCode" },
                { label: "订单状态", prop: "status" },
              
            ],
            isLoading: false,//loading
            pendParams:null
        }
    },
    methods: {
        getList(pageCurrent) {
            if(pageCurrent){
                this.page.current = pageCurrent;
            }
            this.isLoading = true;
            let params = {
                current: this.page.current,
                size: this.page.size,
            }
            if(this.pendParams){
                params = Object.assign(params,this.pendParams);
            }
            goodsStatisticsPageForPlatform(params).then(res => {
                this.tableData = res.records || [];
                this.page.total = res.total || 0;
            }).finally(() => {
                this.isLoading = false;
            })
            
        },
        publicGetData(e) {
            if(e){
                this.pendParams = e;
            }
            this.getList(1);
        }
    }
}
</script>


<style scoped lang="scss">
.pl-sales-statistic-table {
    padding: 10px;
    background-color: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    overflow: hidden;

}
</style>